import { apiFetch } from "@/integrations/backend/client";

export type AdminSettings = {
  id?: string;
  default_sender_name: string;
  default_sender_email: string;
  created_at?: string | null;
  updated_at?: string | null;
} | null;

export async function getAdminSettings(): Promise<AdminSettings> {
  const res = await apiFetch("/api/v1/admin/settings", { method: "GET" });
  if (!res.ok) throw new Error(`admin_settings_get_failed:${res.status}`);
  return (await res.json()) as AdminSettings;
}

export async function upsertAdminSettings(input: { default_sender_name: string; default_sender_email: string }): Promise<void> {
  const res = await apiFetch("/api/v1/admin/settings", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(`admin_settings_put_failed:${res.status}`);
}
